import styles from './index.module.less';
import { Web3SecondHeader } from '@web3fe/infra';
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import { Header } from '@/containers/bybitsol/header';
import { Community } from '@/containers/bybitsol/community';
import { BbSolConfigProvider } from '@/components/providers/bbsolInfo';
import { ProductOverview } from '@/containers/bybitsol/productOverview';
import { EarnSteps } from '@/containers/bybitsol/earnSteps';
import { ExchangeSection } from '@/containers/bybitsol/exchangeSection';
import { DappSection } from '@/containers/bybitsol/dappSection';
import { StakingSlides } from '@/containers/bybitsol/stakingSlides';
import { StakingNow } from '@/containers/bybitsol/stakingNow';
import { RewardSlides } from '@/containers/bybitsol/rewardSlides';
import { NoSSR } from '@web3/base-components';
import useAirdropActivity from '@/hooks/useAirdrop';
import { RewardsModal as AirdropRewardsModal } from '@/containers/operation/airdrop/Rewards';

export const BybitSOL = () => {
  const activityCode = 'bbsol';
  const { activity } = useAirdropActivity(activityCode);
  //
  return (
    <BbSolConfigProvider>
      <div className={styles.container}>
        <div className={styles['hero-wrap']}>
          {activity && (
            <div className={styles['hero-wrap-bg-wrap']}>
              <div className={styles['hero-wrap-bg-container']}>
                <img src={activity?.webPic} className="hidden sm:block" />
                <img
                  src={activity?.appPic}
                  className="block sm:hidden h-auto w-auto"
                />
              </div>
            </div>
          )}

          <div className="relative z-[2]">
            <NoSSR>
              <div className={styles.secondHeader}>
                <Web3SecondHeader />
              </div>
            </NoSSR>
            <Header activity={activity} />
          </div>
        </div>

        <RewardSlides />
        <ProductOverview />
        <EarnSteps />
        <StakingSlides />
        <ExchangeSection />
        <DappSection />
        <Community />
        <StakingNow activity={activity} />
        <AirdropRewardsModal activity={activity} />
      </div>
    </BbSolConfigProvider>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage(
    'web3-staking',
    {
      locale,
      entry: import.meta.url,
      additions: [],
    },
    false
  );

  return {
    props: {
      locale,
      messages,
      title:
        'bbSOL Liquid Staking on Bybit Web3 - Earn Yield on Solana with DeFi',
      description:
        'Maximize your SOL earnings with bbSOL on Bybit Web3. Stake, trade, and leverage DeFi to unlock higher rewards and flexible liquidity. Start staking today!',
      keywords:
        'bbSOL, Bybit Web3, SOL staking, Solana staking, yield farming, crypto staking, Solana liquid staking, Web3 staking, Solana DeFi',
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};

export default BybitSOL;
